import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {KeepCollapseOpenDirective} from './shared/directives/keep-collapse-open.directive';
import {HomeComponent} from './home/home.component';
import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClient, HttpClientModule, provideHttpClient, withInterceptors} from '@angular/common/http';
import {backfillSession} from './shared/session-backfill';
import {CarouselModule} from 'ngx-bootstrap/carousel';
import {CommonModule} from '@angular/common';
import {RegisterComponent} from './register/register.component';
import {LoginComponent} from './login/login.component';
import {ProfileComponent} from './profile/profile.component';
import {RegisterFormComponent} from './register-form/register-form.component';
import {VisionComponent} from './vision/vision.component';
import {ViewEventComponent} from './view-event/view-event.component';
import {AboutRanaComponent} from './about-rana/about-rana.component';
import {ConstitutionComponent} from './constitution/constitution.component';
import {CommitteeComponent} from './committee/committee.component';
import {ChapterComponent} from './chapter/chapter.component';
import {BizDirectoryComponent} from './biz-directory/biz-directory.component';
import {BizDetailComponent} from './biz-detail/biz-detail.component';
import {BizFormComponent} from './biz-form/biz-form.component';
import {BizCardComponent} from './biz-card/biz-card.component';
import {BizHostComponent} from './biz-host/biz-host.component';
import {BizOpportunitiesComponent} from './biz-opportunities/biz-opportunities.component';
import {BizStartUpComponent} from './biz-start-up/biz-start-up.component';
import {ChapterHomeComponent} from './chapter-home/chapter-home.component';
import {ChapterMomComponent} from './chapter-mom/chapter-mom.component';
import {MedicalHelpComponent} from './medical-help/medical-help.component';
import {NecMomComponent} from './nec-mom/nec-mom.component';
import {GeneralBodyMeetingComponent} from './general-body-meeting/general-body-meeting.component';
import {NgxPaginationModule} from 'ngx-pagination';
import {DataTablesModule} from 'angular-datatables';
import {NewsEventsComponent} from './news-events/news-events.component';
import {NotificationsComponent} from './notifications/notifications.component';
import {PresidentNoteComponent} from './president-note/president-note.component';
import {RegisterFormPaymentComponent} from './register-form-payment/register-form-payment.component';
import {RegisterFormListComponent} from './register-form-list/register-form-list.component';
import {ViewUserRegistrationComponent} from './view-user-registration/view-user-registration.component';
import {GalleryComponent} from './gallery/gallery.component';
import {TermsAndConditionComponent} from './terms-and-condition/terms-and-condition.component';
import {EducationComponent} from './education/education.component';
import {MatrimonialComponent} from './matrimonial/matrimonial.component';
import {BusinessComponent} from './business/business.component';
import {BlogComponent} from './blog/blog.component';
import {BlogFeedComponent} from './blog-feed/blog-feed.component';
import {BlogEditorComponent} from './blog-editor/blog-editor.component';
import {PdfViewerModule} from 'ng2-pdf-viewer'; // Import the PDF Viewer Module
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule} from 'ngx-toastr';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {NgxEditorModule} from 'ngx-editor';
import {CounterUpDirective} from './home/counter';
import {CreateCommitteeComponent} from './create-committee/create-committee.component';
import {customInterceptor} from './api/custom.interceptor';
import {RecoverPasswordComponent} from './recover-password/recover-password.component';
import {UpdateUserComponent} from "./update-user/update-user.component";
import {LoadingSpinnerComponent} from './shared/loading-spinner/loading-spinner.component'; // Import LoadingSpinnerComponent
import {MemberSearchSelectComponent} from './shared/member-search-select/member-search-select.component';
import {ContactUsComponent} from './contact-us/contact-us.component';
import {UserCardComponent} from './user-card/user-card.component';
import {ChapterEventComponent} from './chapter-event/chapter-event.component';
import {FinanceComponent} from './finance/finance.component';
import {ThemeSwitcherComponent} from './theme/theme-switcher.component';
import {QuestionEditorComponent} from './registration-questions/question-editor.component';
import {RegistrationEditDialogComponent} from './registration-edit-dialog/registration-edit-dialog.component';
import {ReasonDialogComponent} from './reason-dialog/reason-dialog.component';
import {QuestionFieldsComponent} from './registration-questions/question-fields.component';
import {EventHomeComponent} from './event-home/event-home.component';
import {EventEmailsComponent} from './event-emails/event-emails.component';
import {EventExpensesComponent} from './event-expenses/event-expenses.component';
import {EventPhotosComponent} from './event-photos/event-photos.component';
import {ImageCropperComponent} from 'ngx-image-cropper';
import {MatrimonialHomeComponent} from './matrimonial-home/matrimonial-home.component';
import {PaymentSuccessComponent} from './payment-success/payment-success.component';
import {PaymentCancelComponent} from './payment-cancel/payment-cancel.component';
import {BizConferenceComponent} from './biz-conference/biz-conference.component';
import {RecaptchaModule} from 'ng-recaptcha';
import {CreateBotComponent} from "./create-bot/create-bot.component";
import {HelpFaqComponent} from './help-faq/help-faq.component';
import {RegisterEventComponent} from './register-event/register-event.component';
import {EventAttendeesComponent} from './event-attendees/event-attendees.component';
import {EventPublicComponent} from './event-public/event-public.component';
import {AdminDocumentsComponent} from './admin-documents/admin-documents.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {SharedModule} from './rt-editor/shared.module';


@NgModule({
    declarations: [
        AppComponent,
        KeepCollapseOpenDirective,
        HomeComponent,
        HeaderComponent,
        FooterComponent,
        RegisterComponent,
        LoginComponent,
        ProfileComponent,
        RegisterFormComponent,
        VisionComponent,
        ViewEventComponent,
        AboutRanaComponent,
        ConstitutionComponent,
        CommitteeComponent,
        ChapterComponent,
        BizDirectoryComponent,
        BizDetailComponent,
        BizFormComponent,
        BizCardComponent,
        BizHostComponent,
        BizOpportunitiesComponent,
        BizStartUpComponent,
        ChapterHomeComponent,
        ChapterMomComponent,
        ChapterEventComponent,
        QuestionEditorComponent,
        FinanceComponent,
        ThemeSwitcherComponent,
        QuestionFieldsComponent,
        RegistrationEditDialogComponent,
        ReasonDialogComponent,
        MedicalHelpComponent,
        NewsEventsComponent,
        NotificationsComponent,
        PresidentNoteComponent,
        RegisterFormPaymentComponent,
        RegisterFormListComponent,
        ViewUserRegistrationComponent,
        GalleryComponent,
        TermsAndConditionComponent,
        EducationComponent,
        MatrimonialComponent,
        MatrimonialHomeComponent,
        BusinessComponent,
        BlogComponent,
        BlogFeedComponent,
        BlogEditorComponent,
        CounterUpDirective,
        CreateCommitteeComponent,
        CreateBotComponent,
        RecoverPasswordComponent,
        UpdateUserComponent,
        UserCardComponent,
        MemberSearchSelectComponent,
        LoadingSpinnerComponent,
        NecMomComponent,
        GeneralBodyMeetingComponent,
        ContactUsComponent,
        EventHomeComponent,
        EventEmailsComponent,
        EventExpensesComponent,
        EventPhotosComponent,
        PaymentSuccessComponent,
        PaymentCancelComponent,
        BizConferenceComponent
        ,
        HelpFaqComponent,
        RegisterEventComponent,
        EventAttendeesComponent,
        EventPublicComponent,
        AdminDocumentsComponent
    ],
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        AppRoutingModule,
        HttpClientModule,
        CommonModule,
        RecaptchaModule,
        FormsModule,
        PdfViewerModule,
        NgxPaginationModule,
        DataTablesModule,
        DragDropModule,
        NgxEditorModule.forRoot({
            locals: {
                // menu
                bold: 'Bold',
                italic: 'Italic',
                code: 'Code',
                blockquote: 'Blockquote',
                underline: 'Underline',
                strike: 'Strike',
                bullet_list: 'Bullet List',
                ordered_list: 'Ordered List',
                heading: 'Heading',
                h1: 'Header 1',
                h2: 'Header 2',
                h3: 'Header 3',
                h4: 'Header 4',
                h5: 'Header 5',
                h6: 'Header 6',
                align_left: 'Left Align',
                align_center: 'Center Align',
                align_right: 'Right Align',
                align_justify: 'Justify',
                text_color: 'Text Color',
                background_color: 'Background Color',
                // popups, forms, others...
                url: 'URL',
                text: 'Text',
                openInNewTab: 'Open in new tab',
                insert: 'Insert',
                altText: 'Alt Text',
                title: 'Title',
                remove: 'Remove',
                enterValidUrl: 'Please enter a valid URL',
            },
        }),
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-top-right',
        }),
        CarouselModule.forRoot(),
        ImageCropperComponent,
        SharedModule,

    ],
    exports: [CounterUpDirective],
    providers: [
        provideAnimationsAsync(),
        provideHttpClient(withInterceptors([customInterceptor])),
        // fills in values a session opened before this release is missing (e.g. roleScope) without a re-login
        {provide: APP_INITIALIZER, useFactory: backfillSession, deps: [HttpClient], multi: true}
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}
